import makeStyles from '@material-ui/core/styles/makeStyles';
import { darken } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  controlPanelContainer: {
    display: 'flex',
    flexGrow: 1,

    marginRight: 60,
    justifyContent: 'flex-end',
    '& >:not(:last-child)': {
      marginRight: 18,
    },
    [theme.breakpoints.down(theme.breakpoints.values.tablet)]: {
      marginRight: 20,
    },
  },
  controlButton: {
    width: 42,
    height: 42,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 6,
    backgroundColor: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropColor,
    color: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropOnColor,
    '&:focus': {
      backgroundColor: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropColor,
    },
    '@media (hover: hover)': {
      '&:hover': {
        backgroundColor: ({ activeTheme }) => darken(theme.reader.colors[activeTheme]?.backdropColor, 0.1),
        color: theme.palette.colors.readerPrimaryColor,
      },
    },
    '@media (hover: none)': {
      '&:hover': {
        backgroundColor: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropColor,
        color: theme.palette.colors.readerPrimaryColor,
      },
    },
    [theme.breakpoints.down(theme.breakpoints.values.tablet)]: {
      width: 36,
      height: 36,
    },
  },
  bookmarkIcon: {
    color: theme.palette.colors.readerPrimaryColor,
  },
  controlIcon: {
    width: 22,
    height: 22,
    color: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropOnColor,
    '@media (hover: hover)': {
      '&:hover': {
        color: theme.palette.colors.readerPrimaryColor,
      },
    },
  },
  popperPaper: {
    marginTop: 19,
  },
  moreMenu: {
    backgroundColor: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropColor,
  },
  moreMenuItem: {
    backgroundColor: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropColor,
  },
  moreMenuText: {
    color: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropOnColor,
  },
}));

export default useStyles;
